import React, { FC } from 'react';

import { getClassNames } from './FluentUISystemIcon.styles';
import { FluentUISystemIconProps } from './FluentUISystemIcon.types';

const FluentUISystemIcon: FC<FluentUISystemIconProps> = ({ block = false, className, color, size, Icon }) => (
  <Icon className={getClassNames(block, color, size, className).fluentUISystemIcon} />
);

export default FluentUISystemIcon;
